import React, { useState, useCallback } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import ErrorBoundary from './components/ErrorBoundary';
import BuildInstructionsLanding from './pages/BuildInstructionsLanding';
import BuildInstructionsUrlRoute from './pages/BuildInstructionsUrlRoute';
import BuildNav from './components/nav/BuildNav';

/**
 * Minimal App component specifically for build.kibu.family
 * navHeight is measured live from the rendered BuildNav so it stays
 * correct at every breakpoint (84px mobile / 104px desktop).
 */
const BuildApp: React.FC = () => {
    const [navHeight, setNavHeight] = useState(104);
    const handleNavHeight = useCallback((h: number) => setNavHeight(h), []);

    return (
        <ErrorBoundary showDetails={true}>
            <BrowserRouter
                future={{
                    v7_startTransition: true,
                    v7_relativeSplatPath: true,
                }}>
                <div className="build-app bg-background">
                    <BuildNav onHeightChange={handleNavHeight} />
                    <Routes>
                        <Route path="/" element={<BuildInstructionsLanding navHeight={navHeight} />} />
                        <Route path="/:productSlug" element={<BuildInstructionsUrlRoute navHeight={navHeight} />} />
                        <Route path="/:productSlug/:version" element={<BuildInstructionsUrlRoute navHeight={navHeight} />} />
                    </Routes>
                </div>
            </BrowserRouter>
        </ErrorBoundary>
    );
};

export default BuildApp;
